// extracted by mini-css-extract-plugin
module.exports = {"modal":"_5VoKX","background":"ZRl7B","cross":"_3sgzn","modalBackDrop":"_1ff87"};